import {
  Component,
  Input,
  OnChanges,
  OnDestroy
} from "@angular/core";

import { OnInit } from "@angular/core";
import { AddBatchDialogComponent } from "../add-batch/add-batch-dialog.component";
import { IncidentService } from "../../services/incident.services";
import { MatDialog } from "@angular/material";
import { MedicineDetailComponent } from "../medicine-detail/medicine-detail.component";
import { BatchDialogComponent } from "../batch-dialog/batch-dialog.component";
import { ProvenanceMapComponent } from "../provenance-map/provenance-map.component";
import { EventBusService } from "../../services/event-bus.service";
import { GlobalCfgService } from '../../services/globalcfg.service';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationDialogComponent } from "../confirm-dialog/confirm-dialog.component";
import { BatchService } from "src/services/batch.services";
import { MessageService } from "src/services/message.service";
import { IncidentChildrenComponent } from "./incident-children/incident-children.component";

@Component({
  selector: "rm-incidents-grid",
  templateUrl: "./grid.component.html",
  styleUrls: ["./grid.component.css"]
})
export class GridComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  productId: string;

  @Input()
  gcp: string;

  @Input()
  batchNum: string;

  @Input()
  gln: string;

  @Input()
  incidentType: string;

  //Used for pagination
  bookmarks: any[] = [];
  totalCount: number = 0;
  pageSize: number = 5;

  subscriptions: any = [];

  incidentsDetailData: any[] = [];
  incidentsColumns: any[] ;
  labels: any;

  role: any;
  user: any;

  constructor(
    private batchService: BatchService,
    private msgService: MessageService,
    private ebService: EventBusService,
    private dialog: MatDialog,
    private incidentService: IncidentService,
    private globalCfgService: GlobalCfgService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.user = this.globalCfgService.getFullUserObj();

    this.labels = this.globalCfgService.getSettingValue('labels');
    this.incidentsColumns= [
      {
        name: "eventTime",
        displayName: "Incident Date",
        type: "date",
        format: "MM/DD/YYYY h:mm A"
      },
      // { name: "medicineId", displayName: "Medicine ID"},
      {
        name: "name",
        displayName: this.labels['medicine'],
        actionable: true,
        tip: "View medicine detail"
      },
      { name: "txnType", displayName: "Transaction Type" },
      { name: "instanceStatus", displayName: "Status" },
      {
        name: "batchNo",
        displayName: "Batch",
        actionable: true,
        tip: "View batch detail"
      },
      { name: "dataRecorded", displayName: "Data Recorded", type: "multipleRowValues" },
      { name: "actions", displayName: "Actions" }
    ];


    this.subscriptions.push(
      this.ebService.realtimeEventValue$.subscribe(event => {
        console.log("Received event data....");
      })
    );

    this.route.parent.url.subscribe(url => {
      //always the first part is role
      this.role = url.values().next().value.path;
      this.loadIncidents();
    });
  }

  ngOnChanges() {
    this.loadIncidents();
  }

  loadIncidents(page?) {
    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
    }

    var obj = {};

    if (this.gcp  && (this.role == 'admin' || this.role == 'brand-owner')) {
      obj['gcp'] = this.gcp;
    }

    if (this.productId != 'all') {
      obj["gtin"] = this.productId;
    }
    if (this.batchNum) {
      obj["batch"] = this.batchNum;
    }
    if (this.gln) {
      obj["gln"] = this.gln;
    }

    obj['eventType'] = this.incidentType && this.incidentType.length > 0 ? this.incidentType : null;

    obj['pageSize'] = (page && page.pageSize) || this.pageSize;

    if (page && page.pageIndex) {
      obj['bookmark'] = this.bookmarks[page.pageIndex];
    }

    if (this.role == "distributor") {
      obj['dappUserId'] = this.user["dappUserId"];
    }

    this.incidentService.getAll(obj).subscribe((response: any[]) => {
      if (page && page.pageIndex) {
        this.bookmarks[page.pageIndex + 1] = response['metadata'].bookmark;
      } else {
        this.bookmarks[1] = response['metadata'].bookmark;
      }
      this.totalCount = response['metadata'].totalCount || 0;

      response['result'].forEach(item => {
        if (item.txnType === 'MONITORED') {
          item["dataRecorded"] = [];
          if(item.temperature && item.temperature !== "") {
            item["dataRecorded"].push('Temp - ' + item.temperature + ' °C');
          }
          if (item.humidity && item.humidity !== "") {
            item["dataRecorded"].push('Hum - ' + item.humidity);
          }
        }
        item["actions"] = [{ name: "where_to_vote", tip: "View Provenance" }];
        if (item.children && item.children.length > 0) {
          item["actions"].push({ name: "group_work", tip: "View Children" });
        }
      });
      this.incidentsDetailData = response['result'];
    });
  }

  onActionableClicked(e) {
    var rec = e.record;
    switch (e.actionName) {
      case "name":
        this.dialog.open(MedicineDetailComponent, {
          width: "2400px",
          data: { medicineId: rec.gtin }
        });
        break;
      case "batchNo":
         this.dialog.open(AddBatchDialogComponent, {
          width: "2400px",
          data: { rec:rec ,
                title: 'Batch Detail'
          }
      
          });
        break;
      default:
        console.log("Unhandled actionable: ", e.actionName);
    }
  }

  onActionClicked(e) {
    var rec = e.record;
    switch (e.actionName.name) {
      case "where_to_vote":

        this.incidentService.getProvenance(rec.incidentId).subscribe(
          (res: any)=> {
            var locations = [];
            var data = res;
            var ln = data.length;
            var latlong = data[0].readPoint;

            for (var i = 0; i < ln; i++) {
              var o = data[i];
              locations.push({
                position: [o.readPoint.lat, o.readPoint.lng],
                label: o.user.name
              });
            }
    
            this.dialog.open(ProvenanceMapComponent, {
              width: "2400px",
              height: "480px",
              data: {
                medicineId: rec.gtin,
                center: {
                  lat: parseFloat(latlong.lat),
                  lng: parseFloat(latlong.lng)
                },
                zoom: 8,
                locations: locations
              }
            });
          }
        );
        case "group_work":
          this.dialog.open(IncidentChildrenComponent, {
            width: "2400px",
            data: { 
              childrenData: rec.children.map(element => ({
                medicine: rec.name,
                IncidentId: rec.incidentId,
                instanceId: element
              }))
            }
          });
        break;
      default:
        console.log("Unhandled action: ", e.actionName);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  styleRow(rec) {
    if (rec.isInvalid) {
      return "invalid-row";
    }
  }

  onPageChanged(page) {
    this.pageSize = page.pageSize;
    this.loadIncidents(page);
  }
}
